import React from 'react';

import { useIntl } from 'react-intl';
import { Outlet } from 'react-router-dom';

import MainLayout from 'src/components/layout/MainLayout';
import { parkingStatusMessages } from 'src/features/monitoring/utils/messages';
import { useTitleStore } from 'src/stores/useTitleStore';

export default function MonitoringLayout() {
    const { setTitle, removeTitle } = useTitleStore();
    const { formatMessage } = useIntl();

    React.useEffect(() => {
        setTitle(formatMessage(parkingStatusMessages.monitoring));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return (
        <MainLayout>
            <Outlet />
        </MainLayout>
    );
}
